import Employees from "../../assets/images/sidebar/employee_managment.svg";

const hrManagementModule = {
  name: "HR Management",
  key: "hr_management",
  imgSrc: Employees,
  submodules: [
    {
      name: "Employee Management",
      key: "employee_management",
      defaultExpanded: false,
      features: [
        {
          key: "employee_dashboard",
          name: "Employee Dashboard",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_employee_dashboard",
              name: "View Employee Dashboard",
              defaultEnabled: true,
              description: "Display employee status cards and table overview"
            },
            {
              key: "add_new_employee",
              name: "Add New Employee",
              defaultEnabled: false,
              description: "Onboard new employees with full profile setup"
            },
            {
              key: "update_employee",
              name: "Update Employee Details",
              defaultEnabled: false,
              description: "Update employees with full profile setup"
            },
            {
              key: "view_employee",
              name: "View Employee Details",
              defaultEnabled: false,
              description: "View employees details"
            },
            {
              key: "change_personal_details",
              name: "Change Personal Details",
              defaultEnabled: false,
              description: "Update employee personal information"
            },
            {
              key: "change_job_details",
              name: "Change Job Details",
              defaultEnabled: false,
              description: "Modify job title, department, reporting structure"
            },
            {
              key: "change_compensation_details",
              name: "Change Compensation Details",
              defaultEnabled: false,
              description: "Update salary, pay type and compensation structure"
            },
            {
              key: "view_client_details",
              name: "View Client Details",
              defaultEnabled: true,
              description: "Access client information (Client Access Roles)"
            },
            {
              key: "change_report_to",
              name: "Change Report to",
              defaultEnabled: false,
              description: "Update reporting manager"
            },
            {
              key: "change_assignees",
              name: "Change Assignees",
              defaultEnabled: false,
              description: "Modify client/order assignees"
            },
            {
              key: "do_clients_transfer",
              name: "Do Clients Transfer",
              defaultEnabled: false,
              description: "Transfer clients between employees"
            },
            {
              key: "activate_deactivate_employees",
              name: "Activate / Deactivate Employees",
              defaultEnabled: false,
              description: "Activate / Deactivate employee accounts"
            },
            {
              key: "view_client_history",
              name: "View Client History",
              defaultEnabled: false,
              description: "See client assignment history"
            },
            {
              key: "clients_assigned_to_assign_clients_to_the_subordinates",
              name: `Can have access to " Clients Assigned to Assign Clients to the Subordinates ".`,
              defaultEnabled: false,
              description: "Assign subordinates to manage assigned clients"
            },
            {
              key: "view_order_details",
              name: "View Order Details",
              defaultEnabled: true,
              description: "Access order information (Order Access Roles)"
            },
            {
              key: "change_report_to_order",
              name: "Change Report to",
              defaultEnabled: false,
              description: "Update reporting structure for orders"
            },
            {
              key: "change_assignees_order",
              name: "Change Assignees",
              defaultEnabled: false,
              description: "Modify order assignees"
            },
            {
              key: "do_orders_transfer",
              name: "Do Orders Transfer",
              defaultEnabled: false,
              description: "Transfer orders between employees"
            },
            {
              key: "deactivate_employees_order",
              name: "Deactivate Employees",
              defaultEnabled: false,
              description: "Deactivate employee accounts (order context)"
            },
            {
              key: "view_order_assignee_history",
              name: "View Order Assignee History",
              defaultEnabled: false,
              description: "See order assignment history"
            },
            {
              key: "orders_assigned_to_assign_orders_to_the_subordinates",
              name: "Can Act Against the Orders Assigned to Assign Orders to the Subordinates.",
              defaultEnabled: false,
              description: "Allow subordinates to manage assigned orders"
            }
          ]
        }
      ]
    },
    {
      name: "Departments",
      key: "departments",
      defaultExpanded: false,
      features: [
        {
          key: "department",
          name: "Department",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_department_list",
              name: "View Department List",
              defaultEnabled: true,
              description: "Display list of all departments"
            },
            {
              key: "add_new_department",
              name: "Add New Department",
              defaultEnabled: false,
              description: "Create new department"
            },
            {
              key: "edit_existing_department",
              name: "Edit Existing Department",
              defaultEnabled: false,
              description: "Modify department details"
            }
          ]
        }
      ]
    },
    {
      name: "Employee , Client & Order Transfer",
      key: "employee_client_order_transfer",
      defaultExpanded: false,
      features: [
        {
          key: "for_employee_transfer",
          name: "For Employee Transfer",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_employee_dashboard",
              name: "View Employee Dashboard",
              defaultEnabled: true,
              description: "Access employee dashboard for transfer actions"
            },
            {
              key: "take_action_transfer_employee_button_access_for_employee",
              name: "Take Action ( Transfer Employee  Button Access ) for Employee",
              defaultEnabled: false,
              description: "Initiate employee transfer (single or bulk)"
            }
          ]
        },
        {
          key: "for_client_transfer",
          name: "For Client Transfer",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_client_transfer_dashboard_list",
              name: "View Client Transfer Dashboard List",
              defaultEnabled: true,
              description: "Show clients available for transfer"
            },
            {
              key: "view_client_transfer_history",
              name: "View Client Transfer History",
              defaultEnabled: false,
              description: "See previous client transfer records"
            },
            {
              key: "transfer_to_employees_one_by_one",
              name: "Transfer to Employees one by One",
              defaultEnabled: false,
              description: "Transfer individual clients"
            },
            {
              key: "can_transfer_to_employees_in_bulk",
              name: "Can Transfer to Employees in Bulk",
              defaultEnabled: false,
              description: "Bulk client transfer capability"
            }
          ]
        },
        {
          key: "for_order_transfer",
          name: "For Order Transfer",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_order_transfer_dashboard_list",
              name: "View Order Transfer Dashboard List",
              defaultEnabled: true,
              description: "Show orders available for transfer"
            },
            {
              key: "view_order_transfer_history",
              name: "View Order Transfer History",
              defaultEnabled: false,
              description: "See previous order transfer records"
            },
            {
              key: "transfer_to_employees_one_by_one",
              name: "Transfer to Employees one by One",
              defaultEnabled: false,
              description: "Transfer individual orders"
            },
            {
              key: "can_transfer_to_employees_in_bulk",
              name: "Can Transfer to Employees in Bulk",
              defaultEnabled: false,
              description: "Bulk order transfer capability"
            }
          ]
        }
      ]
    }
  ]
};

export default hrManagementModule;
